import { createAction } from '@reduxjs/toolkit';
export const threadListsUpdated = createAction('viewCounts/threadListsUpdated', payload => ({
  payload
}));